import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { B2CIntro } from 'Images';

export const Intro = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.B2C).Landing;

  return (
    <Stack alignItems='center' gap='24px' mb='44px'>
      <Typography variant='h3'>{dictionary.title}</Typography>
      <Avatar alt='' src={B2CIntro} sx={{ width: '180px', height: '177px' }} />
      <Typography variant='body6'>{dictionary.subTitle}</Typography>
    </Stack>
  );
};
